import {LivePenaltiesModuleController} from "../live-penalties-module.controller";
import {FetchHandler} from "../../../infrastructure/handlers/fetch-handler";
import {BaseApiRequestParams} from "../../../infrastructure/models/params/base-api-request-params";
import {ACTION_TYPES, COMPONENT_STATES, SESSION_STORAGE_KEYS} from "../../../core/consts";
import {AthleteEventsChartRequestParams} from "../../../domain/athlete-events-chart/athlete-events-chart.request-params";
import {AthleteEventsChartDataSource} from "../../../domain/athlete-events-chart/athlete-events-chart.data-source";
import {AthleteEventsChartDomainService} from "../../../domain/athlete-events-chart/services/athlete-events-chart.domain-service";
import {SessionStorageUtils} from "../../../infrastructure/utils/session-storage.utils";
import {LIVE_PENALTIES} from "../live-penalties-module.consts";
import type {LivePenaltiesModuleState} from "../models/live-penalties-module.state";

export class LivePenaltiesModuleFetchHandler extends FetchHandler {
  controller: LivePenaltiesModuleController;
  state: LivePenaltiesModuleState;

  static injectables = [AthleteEventsChartDomainService, SessionStorageUtils];

  constructor(service: AthleteEventsChartDomainService, sessionStorageUtils: SessionStorageUtils) {
    super(service);

    this.sessionStorageUtils = sessionStorageUtils;
  }

  onLoaded() {
    super.onLoaded();

    this.action();
  }

  get requestParams(): BaseApiRequestParams {
    const athleteIds = this.controller.props.athleteIds;

    const requestParams: AthleteEventsChartRequestParams = new AthleteEventsChartRequestParams(athleteIds);

    return requestParams;
  }

  async action() {
    const dataSource: AthleteEventsChartDataSource = await this.fetch();
    await this.controller.action(ACTION_TYPES.populateData, {dataSource}).then(() => {
      this.controller.action(LIVE_PENALTIES.ACTION_TYPES.onDisplay, {
        gameId: this.controller.props.gameId,
        competitorId: this.state.competitorVM.id,
        athleteId: this.state.selectedAthlete.id
      })
    });

    this.store.setComponentState(COMPONENT_STATES.loaded);

    return dataSource;
  }

  onUnloaded() {
    super.onUnloaded();

    this.sessionStorageUtils.set(SESSION_STORAGE_KEYS.livePenalties, null);
  }
}
